import { useMemo } from 'react';

import { IServiceAuditorFinding } from '@commenda/api/agent-platform/service-auditor/types';

import { MarkdownRenderer } from '../../../components/MarkdownRenderer';
import { SignedFileLink } from '../../../components/SignedFileLink';
import { ServiceAuditCitationHelper } from '../helpers/ServiceAuditCitationHelper';

interface IServiceAuditFindingDetailsProps {
  finding: IServiceAuditorFinding;
}

/** The expert part of a finding: its full message, then every citation expanded as proof. */
export const ServiceAuditFindingDetails = ({
  finding,
}: IServiceAuditFindingDetailsProps) => {
  const citationViews = useMemo(
    () => ServiceAuditCitationHelper.getCitationViews(finding),
    [finding]
  );

  return (
    <>
      <div className="break-words txt-small-regular text-text-primary">
        <MarkdownRenderer content={finding.message} />
      </div>
      <div className="flex flex-col gap-md">
        <span className="txt-extra-small-regular text-text-tertiary">
          {ServiceAuditCitationHelper.PROOF_LABEL}
        </span>
        {citationViews.length === 0 ? (
          <p className="txt-extra-small-regular text-text-tertiary">
            {ServiceAuditCitationHelper.SOURCE_NOT_RECORDED}
          </p>
        ) : (
          citationViews.map(({ key, quote, source }) => (
            <div
              key={key}
              className="flex flex-col gap-xs rounded-lg border border-border-primary bg-bg-secondary px-md py-md"
            >
              <span className="break-words txt-small-regular text-text-secondary">
                “{quote}”
              </span>
              {source.file ? (
                <SignedFileLink
                  file={source.file}
                  label={source.text}
                  className="h-auto whitespace-normal break-words text-left"
                />
              ) : (
                <span className="break-words txt-extra-small-regular text-text-tertiary">
                  {source.text}
                </span>
              )}
            </div>
          ))
        )}
      </div>
    </>
  );
};
